import type { ComponentProps } from "react";

import type { TableCell } from "@skilitics/designer-ui-components";

import type { invoicesFormatStrings } from "./formatStrings.ts";

type Column = {
  id: keyof typeof invoicesFormatStrings;
  minWidth?: number;
  width?: number;
  align: ComponentProps<typeof TableCell>["align"];
};

export const invoicesColumns: Column[] = [
  {
    id: "createdDate",
    minWidth: 0,
    align: "left",
  },
  {
    id: "dueDate",
    minWidth: 0,
    align: "left",
  },
  {
    id: "status",
    minWidth: 0,
    align: "center",
  },
  {
    id: "amount",
    minWidth: 0,
    align: "right",
  },
  {
    id: "invoice",
    minWidth: 0,
    align: "center",
  },
];
